import React from 'react';
import { useSelector } from 'react-redux';
import StepHeader from '~/components/shared/Stepper/components/StepHeader';
import { RootState } from '~/store/types/sharedTypes';

const BankInformationHeader = () => {
  const { bankAccounts } = useSelector(
    (state: RootState) => state.onboardingOffer.overview
  );

  const title = 'OnboardingOffer.ConfirmBankAccountTitle';
  const hasBankAccounts = !!bankAccounts?.length;
  const description = hasBankAccounts
    ? 'OnboardingOffer.ConfirmBankAccountDescriptionIfExist'
    : 'OnboardingOffer.ConfirmBankAccountDescriptionIfNotExist';

  return <StepHeader title={title} description={description} />;
};

export default BankInformationHeader;
